import type { Definition } from "../definitions";
import type { Change } from "../format";
import { ChangeNote } from "./change-note";
import { MetricLabel } from "./metric-label";

/**
 * One figure inside a card (money, right now): the metric's name with its meaning, the figure and,
 * when there is one, its change against the previous period. No tile frame: a card never holds
 * tiles (the KPI tiles stand on the page on their own).
 */
export function MetricFigure({ definition, value, change, upIsGood, children }: {
  definition: Definition;
  value: string;
  change?: Change;
  upIsGood?: boolean;
  /** Drawn beside the figure (a sparkline). */
  children?: React.ReactNode;
}) {
  return (
    <div className="flex min-w-0 flex-col gap-1">
      <span className="text-body-2 text-t-secondary"><MetricLabel definition={definition} /></span>
      <div className="flex min-w-0 items-end gap-4">
        <span className="shrink-0 text-h5 text-t-primary">{value}</span>
        {children}
      </div>
      {change ? <ChangeNote change={change} upIsGood={upIsGood} /> : null}
    </div>
  );
}
